function newId(prefix) {
  return `${prefix}_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
}

export function createFooterLink(partial = {}) {
  return {
    id: newId("flink"),
    label: "",
    link: "/",
    ...partial,
  };
}

export function createFooterColumn(partial = {}) {
  return {
    id: newId("fcol"),
    title: "Menu",
    ...partial,
    items: Array.isArray(partial.items) ? partial.items.map((item) => createFooterLink(item)) : [],
  };
}

export function defaultFooterMenus() {
  return [
    createFooterColumn({
      id: "footer_explore",
      title: "Explore",
      items: [
        { id: "fe_home", label: "Home", link: "/" },
        { id: "fe_collections", label: "Collections", link: "/collection" },
        { id: "fe_wishlist", label: "My Wishlist", link: "/wishlist" },
        { id: "fe_about", label: "About Us", link: "/about" },
        { id: "fe_contact", label: "Contact", link: "/contact" },
        { id: "fe_cart", label: "Shopping Cart", link: "/cart" },
      ],
    }),
    createFooterColumn({
      id: "footer_care",
      title: "Customer Care",
      items: [
        { id: "fc_track", label: "Track Shipment", link: "/track-order" },
        { id: "fc_shipping", label: "Shipping Policy", link: "/policies/shipping" },
        { id: "fc_returns", label: "Returns & Refunds", link: "/policies/refund" },
        { id: "fc_privacy", label: "Privacy Policy", link: "/policies/privacy" },
        { id: "fc_terms", label: "Terms & Conditions", link: "/policies/terms" },
        { id: "fc_warranty", label: "Warranty Information", link: "/about" },
        { id: "fc_payment", label: "Payment Methods", link: "/about" },
        { id: "fc_faq", label: "FAQs & Help", link: "/about" },
      ],
    }),
  ];
}

export function resolveFooterMenus(settings) {
  if (!Array.isArray(settings?.footerMenus)) return defaultFooterMenus();
  return settings.footerMenus
    .map((column) => ({
      id: column?.id || newId("fcol"),
      title: column?.title || "",
      items: Array.isArray(column?.items)
        ? column.items
            .filter((item) => item && String(item.label || "").trim())
            .map((item) => ({
              id: item.id || newId("flink"),
              label: item.label,
              link: item.link || "",
            }))
        : [],
    }))
    .filter((column) => column.title.trim() || column.items.length > 0);
}
